module.exports = __webpack_public_path__ + "static/media/slide08.1ee15c68.jpg";